import { PromptRequest, PromptTypeKey } from "../../../types/promptTypes";
import FieldContainer from "./FieldContainer";
import { usePromptStore } from "../../../store/promptStore";
import InputField from "../../dynamic/InputField";

type CodeFieldProps = {
  key: string;
  index: number;
  onEnter?: () => void;
};

const CodeField: React.FC<CodeFieldProps> = ({ index, onEnter }) => {
  const prompts = usePromptStore((state) => state.prompts);
  const field = prompts[index] as PromptRequest<PromptTypeKey.CODE>;
  const promptValue = usePromptStore((state) => state.promptValues[index]);
  const setPromptValue = usePromptStore((state) => state.setPromptValue);

  return (
    <FieldContainer field={field}>
      <InputField
        label={field.label}
        value={promptValue}
        onChange={(value) => setPromptValue(index, value)}
        placeholder={"Code"}
        onEnter={onEnter}
        autoFocus={index === 0}
      />
    </FieldContainer>
  );
};

export default CodeField;
